module.exports = {"430682001":"长安街道","430682003":"桃矿街道","430682004":"五里牌街道","430682005":"云湖街道","430682101":"忠防镇","430682103":"聂市镇","430682105":"江南镇","430682107":"桃林镇","430682108":"长塘镇","430682109":"白羊田镇","430682110":"詹桥镇","430682113":"黄盖镇","430682114":"羊楼司镇","430682115":"坦渡镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430682.json
// module id = 1994
// module chunks = 0